import _ from "lodash";

export const pushToFirst = (item, array, key) => {
  if (!item) {
    return array;
  }
  item = _.find(array, [key, item]);
  if (!item) {
    return array;
  }
  _.pull(array, item);
  array.unshift(item);
  return array;
};

export const range = (from, to) => {
  if (!from || isNaN(from)) {
    return [];
  }
  if (to === undefined) {
    to = from - 1;
    from = 0;
  }
  return [...Array(to - from + 1).keys()].map((i) => i + from);
};

export const formatOptions = (data) => {
  const noneOptions = [{ value: "", label: "" }];
  if (!data || data.length === 0) {
    return noneOptions;
  }

  return data.map((item) => ({
    value: item.id,
    label: item.name,
  }));
};
